(function () {

    angular
        .module('smartertoolsApp')
        .directive('stLoading', [stLoading]);

    function stLoading() {
        return {
            template:
                "<div class='row'>" +
                "  <div class='col-sm-12 text-center' style='margin-top: 6rem;'>" +
                "    <div us-spinner='{lines:13, length:20, width:10, radius:30, corners:1, rotate:0, direction:1, speed:2, trail:60, shadow:true}'></div>" +
                '  </div>' +
                '</div>'
        };
    }

})();
